<kendo-dialog
  [title]="titleKey() | translate"
  [width]="480"
  [maxWidth]="'90%'"
  [style.z-index]="'.k-window, .ui-dialog' | maxZIndex: 99990"
  (close)="cancelled.emit()"
>
  <dl
    class="ai-action-dialog-rows m-0 grid gap-x-4 gap-y-3 text-body-2 text-black"
  >
    <dt class="text-caption font-medium text-neutral-70 pt-0.5">
      {{ 'iqboost.suggestedActions.dialog.type' | translate }}
    </dt>
    <dd class="m-0 flex items-center gap-1.5">
      <span
        class="icon-12 shrink-0 text-neutral-70"
        [class]="icon()"
        aria-hidden="true"
      >
      </span>
      {{ typeKey() | translate }}
    </dd>

    <dt class="text-caption font-medium text-neutral-70 pt-0.5">
      {{ 'iqboost.labels.title' | translate }}
    </dt>
    <dd class="m-0 break-words">{{ action().title }}</dd>

    @if (action().description; as description) {
      <dt class="text-caption font-medium text-neutral-70 pt-0.5">
        {{ 'iqboost.labels.description' | translate }}
      </dt>
      <dd class="m-0 break-words whitespace-pre-line">{{ description }}</dd>
    }

    @if (action().reason; as reason) {
      <dt class="text-caption font-medium text-neutral-70 pt-0.5">
        {{ 'iqboost.suggestedActions.dialog.reason' | translate }}
      </dt>
      <dd class="m-0 break-words">{{ reason }}</dd>
    }

    <dt class="text-caption font-medium text-neutral-70 pt-0.5">
      {{ 'iqboost.suggestedActions.dialog.for' | translate }}
    </dt>
    <dd class="ai-action-dialog-for m-0 break-words">
      @if (action().withEntityKey) {
        {{ name() ?? ('iqboost.suggestedActions.dialog.unnamed' | translate) }}
      } @else {
        {{ 'iqboost.suggestedActions.dialog.personal' | translate }}
      }
    </dd>

    <dt class="text-caption font-medium text-neutral-70 pt-0.5">
      {{ 'iqboost.suggestedActions.dialog.when' | translate }}
    </dt>
    <dd class="ai-action-dialog-when m-0" [class.text-warning-140]="past()">
      {{ date() }}
      @if (past()) {
        <span class="ai-action-dialog-past block text-caption">
          {{ 'iqboost.suggestedActions.past' | translate }}
        </span>
      }
    </dd>
  </dl>

  <kendo-dialog-actions layout="end">
    <button
      kendoButton
      type="button"
      class="ai-action-cancel"
      fillMode="outline"
      (click)="cancelled.emit()"
    >
      {{ 'iqboost.buttons.cancel' | translate }}
    </button>
    <button
      kendoButton
      type="button"
      class="ai-action-confirm"
      themeColor="primary"
      (click)="confirmed.emit()"
    >
      {{ 'iqboost.buttons.create' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
